export function getAppMode() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : ''
    const pathname = typeof window !== 'undefined' ? window.location.pathname : ''

    if (
        hostname.includes('admin.velotrax.sa') ||
        hostname.startsWith('dev-admin') ||
        hostname.includes('admin.')
    ) {
        return 'admin'
    }

    if (
        hostname.includes('portal.velotrax.sa') ||
        hostname.startsWith('dev-portal') ||
        hostname.includes('portal.')
    ) {
        return 'partner'
    }

    // Path-based fallback: /partner/* or /admin/* explicit routes
    if (pathname.startsWith('/partner/')) return 'partner'
    if (pathname.startsWith('/admin/')) return 'admin'

    // URL query override for testing
    if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search)
        const mode = params.get('mode')
        if (mode === 'admin' || mode === 'partner') return mode
    }

    return 'partner'
}
